import React from 'react';

interface LiquidImageProps {
    src: string;
    alt?: string;
    // Optional: Definiert, wie stark die Verzerrung sein soll (Standard: 8)
    intensity?: number;
}

export const LiquidImage: React.FC<LiquidImageProps> = ({
                                                            src,
                                                            alt = "Liquid Image",
                                                            intensity = 8
                                                        }) => {
    return (
        <div style={{ position: 'relative', width: '100%', overflow: 'hidden' }}>
            {/*
        Das Bild, auf das der SVG-Filter angewendet wird.
        Speicherplatzbedarf für die Animation: 0 Bytes!
      */}
            <img
                src={src}
                alt={alt}
                style={{
                    width: '100%',
                    height: 'auto',
                    display: 'block',
                    // Verknüpft das Bild mit dem unsichtbaren SVG-Filter unten
                    filter: 'url(#liquid-filter)',
                }}
            />

            {/* Unsichtbares SVG-Element, das den Verzerrungs-Filter bereitstellt */}
            <svg width="0" height="0" style={{ position: 'absolute', pointerEvents: 'none' }}>
                <filter id="liquid-filter">
                    {/* feTurbulence erzeugt ein Wolken/Wellen-artiges Rauschen */}
                    <feTurbulence
                        type="fractalNoise"
                        baseFrequency="0.015 0.03"
                        numOctaves="2"
                        result="noise"
                    >
                        {/*
              Die Animation läuft 3 Sekunden, wie gewünscht.
              Sie verändert sanft die Rausch-Frequenz, wodurch ein Fließen simuliert wird.
            */}
                        <animate
                            attributeName="baseFrequency"
                            dur="3s"
                            values="0.015 0.03; 0.02 0.04; 0.015 0.03"
                            repeatCount="indefinite"
                        />
                    </feTurbulence>

                    {/* feDisplacementMap nutzt das Rauschen, um die Pixel des Originalbilds zu verschieben */}
                    <feDisplacementMap
                        in="SourceGraphic"
                        in2="noise"
                        scale={intensity}
                        xChannelSelector="R"
                        yChannelSelector="G"
                    />
                </filter>
            </svg>
        </div>
    );
};
